import { render, staticRenderFns } from "./ManterCanalProspeccao.vue?vue&type=template&id=43c2b534"
import script from "./ManterCanalProspeccao.vue?vue&type=script&lang=ts"
export * from "./ManterCanalProspeccao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports